( function () {
	'use strict';

	// custom headers
	function headers () {
		return {
			'x-engine-id'     : '1dbae407-f228-4803-b1ef-89f6aaf1bb69',
			'x-engine-secret' : 'YzM4NmY0MGU0YzAzOWIzMTc1NzgzMTI4ZmQzYTFkYzAwMzIyOGFjMTY2NmU4YTA2YTUzY2U0ZGRlNmU5ZWFjNg=='
		};
	}

	// Error messages
	function errorMessages () {
		return {
			'fetchingData'               : 'Error fetching data.',
			'authError'                  : 'Unauthorized.',
			'obsSubmittingError'         : 'Unable to submit this observation.',
			'manageShareFetchingError'   : 'Unable to retrieve data for selected user(s).',
			'manageShareSubmittingError' : 'Unable to save privilege. Please refresh the page and try again.',
			'tplCreationError'           : 'Template creation failed. Please try again.',
			'tplCreationFieldsError'     : 'Unable to save. Please fill out required fields',
			'tplCreationForbidden'       : 'You don\'t have privileges to create a template',
			'tplFormulaMissingPrefix'    : 'Missing',
			'indicatorDeleteError'       : 'Item is part of the section formula, remove from the formula and try again.'
		};
	}

	// information messages
	function info () {
		return {
			'obsSwitcherUsed'   : 'Observation lists switcher used.',
			'obsPreviewUsed'    : 'Observation preview used.',
			'obsLinkClicked'    : 'Observation link clicked.',
			'obsNoFilter'       : 'No Filter',
			'obsStartTimer'     : 'Timer is running. Navigating away may not save your data.',
			'obsUploadProgress' : 'File upload is still in progress...'
		};
	}

	// page titles
	function title () {
		return {
			'obsPreview'      : 'Preview Observation',
			'obsEdit'         : 'Edit Observation',
			'evidence'        : 'Evidence',
			'templatePreview' : 'Template Preview'
		};
	}

	// authorization status
	function authErrorMessages () {
		return {
			'loginInvalid'        : 'Some fields are missing.',
			'loginFailed'         : 'Invalid username and password combination.',
			'loginWithoutLicense' : 'You do not have a license to log in to Edivate Observe. Contact your system administrator, or call the School Improvement Network Support line at 1-855-337-7500.'
		};
	}

	function apiMessages () {
		return {
			'dataSaved'        : 'Data Saved.',
			'updateSuccessful' : 'Update Successful.',
			'notFound'         : 'Not Found'
		};
	}

	function evidencesIcons () {
		return {
			'3' : 'icon-paper-clip',
			'4' : 'icon3-observation-note',
			'5' : 'icon-paper-clip',
			'6' : 'icon3-observation-counter',
			'7' : 'icon3-observation-timer',
			'8' : 'icon3-observation-script'

		};
	}

	function scheduleMessage () {
		return {
			'pastEvents' : 'Please select a time in the future.',
			'invitee'    : 'Invitee'
		};
	}

	function tooltipMessage () {
		return {
			'attachedEvidenceMsg'               : 'This evidence is attached to the current location',
			'attachEvidenceMsg'                 : 'Attach this evidence to the current location',
			'detachEvidenceMsg'                 : 'Detach evidence from this location',
			'evidencePrivateMsg'                : 'Evidence is hidden from everyone other than the performer of this observation',
			'evidencePublicMsg'                 : 'Evidence is visible to anyone with viewing privileges over this observation',
			'obsEditNumber'                     : 'Click to edit number',
			'obsEditText'                       : 'Click to edit text',
			'timerEvidenceMsg'                  : 'Create a new timer evidence',
			'counterEvidenceMsg'                : 'Create a new counter evidence',
			'textEvidenceMsg'                   : 'Create a new text evidence',
			'fileEvidenceMsg'                   : 'Create a new file evidence',
			'obsEditMsg'                        : 'Click to edit title',
			'obsTypeMsg'                        : 'Select type of observation',
			'obsFilterMsg'                      : 'Select custom filter tags',
			'obsStartDateMsg'                   : 'Edit observation start date',
			'obsEndDateMsg'                     : 'Edit observation end date',
			'obsStartTimeMsg'                   : 'Edit observation start time',
			'obsEndTimeMsg'                     : 'Edit observation end time',
			'obsEvidenceMsg'                    : 'Manage evidence relating to the observation as a whole',
			'obsPDMsg'                          : 'Manage PD assignments relating to the observation as a whole',
			'obsGroupEvidenceMsg'               : 'Manage evidence relating to this section',
			'obsGroupPDMsg'                     : 'Manage PD assignments relating to this section',
			'obsIndicatorEvidenceMsg'           : 'Manage evidence relating to this indicator',
			'obsIndicatorPDMsg'                 : 'Manage PD assignments relating to this indicator',
			'compeletedObsEvidenceMsg'          : 'Attached Evidence relating to this observation',
			'compeletedObsPDMsg'                : 'Assigned Professional Development relating to this observation',
			'compeletedObsGroupEvidenceMsg'     : 'Attached Evidence relating to this section',
			'compeletedObsGroupPDMsg'           : 'Assigned Professional Development relating to this section',
			'compeletedObsIndicatorEvidenceMsg' : 'Attached Evidence relating to this indicator',
			'compeletedObsIndicatorPDMsg'       : 'Assigned Professional Development relating to this indicator',
			'obsUpMsg'                          : 'Hide observation details',
			'obsDownMsg'                        : 'Show observation details',
			'obsShowQAccessMsg'                 : 'Show quick access panel for counters and timers',
			'obsHideQAccessMsg'                 : 'Hide quick access panel',
			'obsLockMsg'                        : 'Lock quick access panel in place',
			'obsUnlockMsg'                      : 'Unlock to expand the quick access panel',
			'obsPrintMsg'                       : 'Download this observation in its current state',
			'obsExportMsg'                      : 'Export this observation in its current state.',
			'obsScriptingMsg'                   : 'Open scripting evidence tool',
			'obsCompleteMsg'                    : 'Finish the observation and prevent further edits.',
			'obsSaveShareMsg'                   : '<div class="tooltip-msg2">Save the observation and make available for review.\nAllows for editing later.</div>',
			'obsSaveCloseMsg'                   : 'Save the observation in its current state and exit.',
			'obsAvailableEvidenceMsg'           : 'This is where you can attach available evidence to the observation as a whole.',
			'obsAttachEvidenceMsg'              : 'This is where you can view, edit, create or remove evidence attached to the observation as a whole.',
			'grpAvailableEvidenceMsg'           : 'This is where you can attach available evidence to the selected section of indicators.',
			'grpAttachEvidenceMsg'              : 'This is where you can view, edit, create or remove evidence attached to the selected section of indicators.',
			'indAvailableEvidenceMsg'           : 'This is where you can attach available evidence to the selected indicator.',
			'indAttachEvidenceMsg'              : 'This is where you can view, edit, create or remove evidence attached to the selected indicator.',
			'templateEditTypesFilterMsg'        : 'Manage standard template filter tags',
			'templateEditCustomFilterMsg'       : 'Manage custom template filter tags',
			'templateEditTitleMsg'              : 'Click to edit title',
			'templateAddFilterMsg'              : 'Add custom filters tags to template',
			'templateEditTagMsg'                : 'Click to edit tag',
			'templateDelTagMsg'                 : 'Remove tag from template',
			'templateScoreMsg'                  : 'Add overall scoring to this template',
			'templateGrpEditTitleMsg'           : 'Click to edit section title',
			'templateGrpFormulaMsg'             : 'Add scoring to this section',
			'templateGrpDeleteMsg'              : 'Remove section from template',
			'templateTmpManagePPDMsg'           : 'Manage PD recommendations related to this template',
			'templateGrpManagePPDMsg'           : 'Manage PD recommendations related to this section',
			'templateOpEndEnableScoreMsg'       : 'Turn on scoring for this indicator',
			'templateOpEndDisableScoreMsg'      : 'Turn off scoring for this indicator',
			'templateOpEndManagePPDMsg'         : 'Manage PD recommendations related to this indicator',
			'templateDeleteIndicatorMsg'        : 'Remove indicator from template',
			'templateEditIndicatorTitleMsg'     : 'Click to edit indicator title',
			'templateRequiredIndicatorMsg'      : 'Require the user to answer this indicator',
			'templateMCMultiSelectMsg'          : 'Allow the user to select multiple options',
			'templateMCEditOptionMsg'           : 'Click to edit option text',
			'templateMCScoreMsg'                : 'Add a value for this option',
			'templateRubEditProfTitleMsg'       : 'Click to edit proficiency title',
			'templateRubEditProfDescMsg'        : 'Click to edit description text',
			'templateRubProfScoreMsg'           : 'Add a value for this proficiency',
			'templatePrintMsg'                  : 'Download a blank copy<br/>of this template',
			'templateAddGroupMsg'               : 'Add an additional section of indicators',
			'templateReorderMsg'                : 'Manage the display order of sections or indicators',
			'templateSaveCloseMsg'              : 'Save the template in its current state and exit',
			'templateHideScoringMsg'            : 'Hide numbered scoring from observers/invitees on a scored template',
			'templateDigitalSignature'          : 'Manage the ability to request digital signatures on observations',
			'templateAttachmentsMsg'            : 'Add a reference document to the template',
			'templateReferenceDownloadMsg'      : 'Download the template reference document',
			'copyMsg'                           : 'Copy Template',
			'deleteMsg'                         : 'Delete Template',
			'manageMsg'                         : 'View and manage others\' rights to this template',
			'noticeMsg'                         : '<div class="tooltip-msg">Assigning privileges at a parent location or section level will assign that same privilege to all sub-sections and individuals belonging to the parent section - making the privilege "inherited." Sub-sections and individuals within the section will only have that privilege assignment by virtue of belonging to the parent section where the privilege is assigned. If an individual leaves the section, they will no longer have that same privilege assignment.\n\nAssigning privileges to an individual (as opposed to a section) will assign the privilege to that particular individual, regardless of any section affiliation. (E.g., If an individual has a particular privilege assigned to him/her, and moves to a different location with the same Edivate account, all privileges assigned at an individual level will persist.)</div>',
			'canUseMsg'                         : '<div class="tooltip-msg">Will grant an individual or section the right to:\n1. Perform an observation using the template.\n2. View and copy the template.\n\nBlocking an individual or section will:\n1. Prevent the individual(s) from using the template.\n2. Override any inherited privileges.</div>',
			'canEditMsg'                        : '<div class="tooltip-msg">Will grant an individual or section the right to:\n1. Edit the template at any time.\n<span class="tooltip-submsg">*NOTE:* Editing a template after an observation has been performed will permanently alter the template. This will not affect observations previously performed using the template.</span>\n\nBlocking an individual or section will:\n1. Prevent the individual(s) from editing the template.\n2. Override any inherited privileges.</div>',
			'canManageMsg'                      : '<div class="tooltip-msg">Will grant an individual or section the right to manage others\':\n1. Use and editing of the template.\n2. Managing others\' rights to the template.\n\nBlocking an individual or section will:\n1. Prevent the individual(s) from managing the template.\n2. Override any inherited privileges.</div>',
			'manageLegend'                      : '<div class="tooltip-msg"><span class="icon-circle-check"></span> = Privilege granted\n<span class="icon-ban"></span> = Privilege blocked\n&nbsp* &nbsp= Privilege assigned at the district or school level\n<span class="icon-square-minus"></span> = No assigned privileges</div>',
			'reportFilterCollapseMsg'           : 'Hide report filters',
			'reportFilterExpandMsg'             : 'Show report filters',
			'closePreview'                      : 'Close preview',
			'copyOptions'                       : 'Copy',
			'manageObsViewLegend'               : '<div class="tooltip-msg"><span class="icon-circle-check"></span> = Privilege granted\n<span class="icon-ban"></span> = Privilege blocked\n<span class="icon-square-minus"></span> = No assigned privileges</div>',
			'manageSelfObsView'                 : 'View and manage others\' view rights to this self-observation',
			'manageObsView'                     : 'View and manage others\' view rights to this observation',
			'editDraftMsg'                      : 'Make changes to the existing template',
			'exportNotFinal'                    : 'Printing of In Review observations is not allowed because they have not been finalized.'
		};
	}

	function ppdMessages () {
		return {
			'calendarMsg' : 'Add a due date to assigned PD',
			'detachMsg'   : 'Detach PD from this location',
			'attachMsg'   : 'Attach this PD to the current location',
			'checkMsg'    : 'This PD is attached to the current location'
		};
	}

	function promptMessages () {
		return {
			'beforeunloadMsg' : 'Timer is still running. Data you have entered may not be saved.'
		};
	}

	function reportFileNames () {
		return {
			'1' : 'ObsByTemplate_',
			'2' : 'ObsByStatus_',
			'3' : 'AssignmentStatusReport_',
			'4' : 'DataExportReport_',
			'5' : 'ProficiencyTrendReport_'
		};
	}

	function fileTypes () {
		return {
			'microcrendential' : 16,
			'observation'      : 17
		};
	}

	function uploadEvidenceWarningMsgs () {
		return {
			'unsupported'      : 'Oops! That type of file isn\'t supported in our system. Please pick a different file and try again.',
			'duplicate'        : 'Oops! It looks like you\'ve already uploaded that file in this location. You should be able to find it in the list of available evidence.',
			'nofile'           : 'No file choosen.',
			'filelimit'        : 'File too large.',
			'failUpload'       : 'Unable to upload file. Please try again.',
			'cancelUpload'     : 'File upload has been canceled.',
			'successUpload'    : 'File has been successfully uploaded.',
			'inProgressUpload' : 'File upload is still in progress. Please wait until uploading process is finished.',
			'pdDuplicate'      : 'Oops! It looks like you\'ve already uploaded that file in this location. You should be able to find it in the list of uploaded files or recommended PDs.'
		};
	}

	function pdfMakeProvider () {
		return function () {
			return window.pdfMake;
		};
	}

	function visualizeProvider () {
		return function () {
			return window.visualize;
		};
	}

	function edivateBaseUrl () {
		return ( window.location.protocol + '//' + window.location.hostname )
			.replace( 'http://localhost', 'https://dev.edivate.com' )
			.replace( 'observe.', '' );
	}

	angular
		.module( 'app.core' )
		.constant( 'ERROR_MSGS', errorMessages() )
		.constant( 'INFO', info() )
		.constant( 'TITLE', title() )
		.constant( 'AUTH_ERROR_MSGS', authErrorMessages() )
		.constant( 'EVDICONS', evidencesIcons() )
		.constant( '_', window._ )
		.constant( '$', window.$ )
		.constant( 'MODERNIZR', window.Modernizr )
		.constant( 'HEADERS', headers() )
		.constant( 'SCHEDULE_MESSAGES', scheduleMessage() )
		.constant( 'API_MESSAGES', apiMessages() )
		.constant( 'TOOLTIP_MESSAGES', tooltipMessage() )
		.constant( 'PPD_MESSAGES', ppdMessages() )
		.constant( 'PROMPT_MESSAGES', promptMessages() )
		.constant( 'FILETYPES', fileTypes() )
		.constant( 'UPLOAD_EVD_MSGS', uploadEvidenceWarningMsgs() )
		.factory( 'pdfMake', pdfMakeProvider )
		.factory( 'visualize', visualizeProvider )
		.constant( 'reportFileNames', reportFileNames() )
		.constant( 'math', window.math )
		.constant( 'svgAsPngUri', window.svgAsPngUri )
		.constant( 'edivateBaseUrl', edivateBaseUrl() )
		.constant( 'saveFileAs', window.saveAs );
} )();
